// ** Initial State
const initialState = {
  list: [],
  dropcardDataWithPagintion: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true,
  update: null,
  delete: null
} 

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DROPS_LIST':
      return { ...state, list: action.data }
    case 'SET_DROPS_LIST_EMPTY':
      return { ...state, list: action.data }
    case 'GET_ALL_DROPCARDS_WITH_PAGINATION':
      return { ...state, dropcardDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }  
    case 'UPDATE_DROPCARD_NOTES':
      return { ...state, update: action.data }  
    case 'DELETE_DROPCARD_NOTES':
      return { ...state, delete: action.data }  
    default:
      return { ...state }
  }
}
export default users
